export default __webpack_public_path__ + "static/media/Qadr.ce91e62e.mp3";